import Rest from '../Rest'

export default class CampaignService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/campaigns'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  /** Ficha completa da campanha — produtos, público, materiais, participações e timeline. */
  detail(id: number) {
    return this.get(`/${id}/detail`)
  }

  awaitingApproval() {
    return this.get('/awaiting_approval')
  }

  publish(id: number) {
    return this.put(`/${id}/publish`, {})
  }

  approve(id: number) {
    return this.put(`/${id}/approve`, {})
  }

  reject(id: number, reason: string) {
    return this.put(`/${id}/reject`, { reason })
  }

  pause(id: number, reason: string) {
    return this.put(`/${id}/pause`, { reason })
  }

  resume(id: number) {
    return this.put(`/${id}/resume`, {})
  }

  cancel(id: number, reason: string) {
    return this.put(`/${id}/cancel`, { reason })
  }

  saveProducts(id: number, products: any[]) {
    return this.put(`/${id}/products`, { products })
  }

  saveAudiences(id: number, audiences: any[]) {
    return this.put(`/${id}/audiences`, { audiences })
  }

  addAsset(id: number, payload: any) {
    return this.post(`/${id}/assets`, payload)
  }

  removeAsset(id: number, assetId: number) {
    return this.delete(`/${id}/assets/${assetId}`)
  }

  invite(id: number, influencerId: number) {
    return this.post(`/${id}/invite`, { influencer_id: influencerId })
  }
}
